import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UtilService } from '../util.service';
import { VenderApi } from './api-vender';

@Injectable({
  providedIn: 'root',
})
export class VenderRedeemService {
  constructor(private util: UtilService, public api: VenderApi, public storage: Storage) {}

  // 取得兌換商品清單
  get_redeem_list(data?: any): Promise<any> {
    let endpoint = 'appv2/item/item_list';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 兌換商品
  redeem_item(data?: any): Promise<any> {
    let endpoint = 'appv2/item/redeem_item';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得兌換紀錄
  get_redeem_record(data?: any): Promise<any> {
    let endpoint = 'appv2/item/redeem_item_log';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      //params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  private extractData(res) {
    console.log(res);
    let body = res; //httpclient , res已經是json
    console.log(body);
    if (body.returnCode === 'OK') {
      return body;
    } else {
      throw { api_error: true, message: body.message };
    }
  }
}
